<template>
    <div id="learning-journeys" class="margin-subpages" style="height: 100%;min-height: 800px;">
        
            <div class="flex-column mt-34">
                <div class="flex-row-between " style="width: 100%;">
                    <el-select v-model="selectTeam" filterable placeholder="Select" class="input-style"
                    :class="[ blurMode ?  'blurelement': '' ]" @change="handleTeams">
                        <el-option v-if="user.user_type !== 'leadership'" class="text-dropdown" key="all" :label="`All Teams (${$utils(
                        'addCommasInNumber',
                        optionsTeam.length
                    )})`" value="all"></el-option>
                        <el-option class="text-dropdown" 
                        :class="[ blurMode ?  'blurelement': '' ]"v-for="item in optionsTeam" :key="item.key" :label="item.name"
                        :value="item.key"></el-option>
                    </el-select>
                    <div style="width: 220px" id="menuDropdownType" class="flex">
                        <el-menu class="el-menu-demo menu-option-style" mode="horizontal">
                        <el-submenu index="0" style="width: 220px">
                            <template slot="title">
                            <span class="txtOption">{{ list_month_select }} </span>
                            </template>
                            <el-menu-item index="1" @click="changeTime('All-time')"
                            style="font-size: 14px; width: 220px">All-time</el-menu-item>
                            <el-menu-item index="2" @click="changeTime('Past year')" style="font-size: 14px; width: 220px">Past
                            year</el-menu-item>
                            <el-menu-item index="3" @click="changeTime('Past 6-months')" style="font-size: 14px; width: 220px">Past
                            6-months</el-menu-item>
                            <el-menu-item index="4" @click="changeTime('Past 3-months')" style="font-size: 14px; width: 220px">Past
                            3-months</el-menu-item>
                        </el-submenu>
                        </el-menu>
                    </div>
                </div>
                <div class="mt-24 fs-18 fw-700">
                    Overview
                </div>
                <div class="flex-row-between mt-10">
                    <div class="card-style flex-center">
                        <div>
                            <img
                            :src="$utils('icons', 'ic_activelearning')"
                            style="height: 48px;width: 48px;"
                            class="ml-12"
                            />
                        </div>
                        <div class="flex-column ml-12">
                            <div class="fs-11">Active Learning Journeys</div>
                            <div class="fs-20 fw-700">{{ overview.active }}</div>

                        </div>


                    </div>
                    <div class="card-style flex-center">
                        <div>
                            <img
                            :src="$utils('icons', 'ic_completed')"
                            style="height: 48px;width: 48px;"
                            class="ml-12"
                            />
                        </div>
                        <div class="flex-column ml-12">
                            <div class="fs-11">Completed Journeys</div>
                            <div class="fs-20 fw-700">{{ overview.completed }}</div>

                        </div>

                    </div>
                    <div class="card-style flex-center">
                        <div>
                            <img
                            :src="$utils('icons', 'ic_upskilled')"
                            style="height: 48px;width: 48px;"
                            class="ml-12"
                            />
                        </div>
                         
                            <div class="flex-column ml-12">
                            <div class="fs-11">Members Upskilled</div>
                            <div class="fs-20 fw-700">{{ overview.upskilling }}</div>
                            </div>

                    </div>
                    <div class="card-style flex-center">
                        <div>
                            <img
                            :src="$utils('icons', 'ic_learningtime')"
                            style="height: 48px;width: 48px;"
                            class="ml-12"
                            />
                        </div>
                        <div class="flex-column ml-12">
                            <div class="fs-11">Learning Time</div>
                            <el-tooltip :content="`${((overview.learning_time * 15)/60).toFixed(1)} hours` + ' or ' + `${((overview.learning_time * 15)/60/24).toFixed(1)} days`" placement="top" effect="light">
                                <div class="fs-20 fw-700">{{ (overview.learning_time * 15).toLocaleString() }} min</div>
                            </el-tooltip>
                        </div>

                    </div>
                  

                </div>
                
                <!-- chart -->
                
                    <div class="mt-24" style="height: 240px;background: #F7F7F7 0% 0% no-repeat padding-box;border-radius: 24px;opacity: 1;padding-left: 35px;">
                            <div class="mt-24 fs-14 fw-700"> Activation Channel</div>
                            <!-- pie chart -->
                            <div class="flex-center">
                                <div class="flex-column" style="width:293px;height:185;">
                                    <div class="fs-12" style="color: var(--unnamed-color-000000);opacity: 0.6;">Learning journeys initiated by managers (performance focus) or self-initiated (personal growth)</div>
                                    <div class="flex-row mt-12">
                                        <div style="width:120px;height:120px;">
                                        <canvas ref="pieChart" width="120" height="120"></canvas>
                                        </div>
                                        <div class="pl-20 mt-55">
                                            <div class="flex-row">
                                                <div class="label-pie mr-6" style="background-color: #32C2D5;"></div>
                                                <div class="fs-11" style="align-content:center">Manager</div>
                                            </div>
                                            <div class="flex-row mt-6">
                                                <div class="label-pie mr-6 " style="background-color: #6C30CC;"></div>
                                                <div class="fs-11" style="align-content:center">Self</div>
                                            </div>
                                        </div>
                                    
                                    </div>
                                
                                    
                                </div>
                                <!-- bar chart -->
                                <div class="flex-center" style="width: 480px;height: 125px;margin-left: 24px;">
                                        <canvas
                                            ref="barChart"
                                            height="120px"
                                            class="barchart-style"
                                        ></canvas>
                                    </div>

                            </div>
                    </div>
                

                <!-- Top Learners Section -->
                <div class="mt-24 compact-section">
                    <div class="flex-row-between">
                        <div>
                            <div class="fs-14 fw-700">Top Learners</div>
                            <div class="fs-11 section-subtitle">Team members with the most learning journeys</div>
                        </div>
                        <div>
                            <span class="view-all-btn" @click="openTopLearnersModal">View All</span>
                        </div>
                    </div>
                    
                    <div class="top-learners-grid mt-8">
                        <div v-for="(learner, index) in topSixLearners" :key="index" class="top-learner-item">
                            <div class="learner-rank">{{ index + 1 }}</div>
                            <div class="learner-profile">
                                <img 
                                    :src="learner.pic || getDefaultAvatar(learner.name)" 
                                    class="learner-avatar"
                                    :class="[ blurMode ?  'blurelement': '' ]"
                                    alt="Learner avatar"
                                />
                            </div>
                            <div class="learner-info">
                                <div class="learner-name" :class="[ blurMode ?  'blurelement': '' ]">{{ learner.name }}</div>
                                <div class="learner-journeys">{{ learner.count }} {{ learner.count === 1 ? 'Journey' : 'Journeys' }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex-center mt-32">
                    <div class="fs-18 fw-700" style="display: flex; align-items: center;">
                        Learning Journey Progress
                        <el-tooltip content="View Skill Category Analytics" placement="top">
                            <span class="analytics-icon-btn" @click="openCategoryAnalyticsModal">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="3" y="10" width="2.5" height="7" rx="1" fill="#6C30CC"/>
                                    <rect x="8.25" y="6" width="2.5" height="11" rx="1" fill="#6C30CC"/>
                                    <rect x="13.5" y="3" width="2.5" height="14" rx="1" fill="#6C30CC"/>
                                </svg>
                            </span>
                        </el-tooltip>
                    </div>
                    <div class="ml-24"> 
                        <el-input
                        class="input-style"
                        style="width: 220px !important;height: 40px !important;"
                        autosize
                        :placeholder="$t('global.Search')"
                        v-model="inputSearch"
                        clearable
                    ></el-input>
                    </div>
                    <div style="margin-left: 133px;">Status</div>
                    <div style="width: 200px; margin-left: 24px;" id="menuDropdownType" class="flex">
                            <el-menu class="el-menu-demo menu-option-style" mode="horizontal">
                            <el-submenu index="0" style="width: 200px">
                                <template slot="title">
                                <span class="txtOption">{{ statusLearning }} </span>
                                </template>
                                <el-menu-item index="0" @click="changeStatus('All')" style="font-size: 14px; width: 200px">All</el-menu-item>
                                <el-menu-item index="1" @click="changeStatus('Not Started')" style="font-size: 14px; width: 200px">Not Started</el-menu-item>
                                <el-menu-item index="2" @click="changeStatus('In Progress')" style="font-size: 14px; width: 200px">In Progress</el-menu-item>
                                <el-menu-item index="3" @click="changeStatus('Completed')" style="font-size: 14px; width: 200px">Completed</el-menu-item>
                            </el-submenu>
                            </el-menu>
                    </div>
                    </div>
                        
                <!-- Category Filter Toolbar -->
                <div v-if="false" class="filter-toolbar">
                    <div class="fs-12">Filter by Category</div>
                    <div style="width: 400px;" id="menuDropdownCategory">
                        <el-menu class="el-menu-demo menu-option-style" mode="horizontal">
                            <el-submenu index="0" style="width: 400px">
                                <template slot="title">
                                    <span class="txtOption text-truncate">{{ selectedCategory }}</span>
                                </template>
                                <el-menu-item index="0" @click="changeCategory('All')" style="font-size: 14px; width: 400px">All</el-menu-item>
                                <el-menu-item v-for="category in uniqueCategories" 
                                    :key="category" 
                                    @click="changeCategory(category)" 
                                    style="font-size: 14px; width: 400px"
                                    class="category-menu-item">
                                    {{ category }}
                                </el-menu-item>
                            </el-submenu>
                        </el-menu>
                    </div>
                </div>

                <!-- Column Headers -->
                <div class="flex-row mt-24">
                    <div class="fs-14 fw-700" style="width: 320px;">Skill Set</div>
                    <div class="fs-14 fw-700" style="width: 180px;">Progress</div>
                    <div class="fs-14 fw-700" style="width: 110px;">Initiated by</div>
                    <div class="fs-14 fw-700" style="width: 120px;">Assigned To</div>
                    <div class="fs-14 fw-700" style="width: 110px;">Date & time</div>
                </div>

                <div v-if="loading"  class="flex-row mt-24" style="align-items: center;justify-content: center;">
                    <loading-even/>
                </div>
                <div v-else>
                    <div class="mt-24">
                        <div v-for="arr in visibleLearningProgress" :key="arr.id" >
                        <div class="relative">
                            <div
                                class="card-layer"
                                style="top: 16px; left: 16px"
                                >
                                &nbsp;
                            </div>
                            <div
                                class="card-layer"
                                style="top: 8px; left: 8px"
                                >
                                &nbsp;
                            </div>
                            <div
                                class="card-layer"
                                style="top: 0px; left: 0px;position: relative !important;margin-bottom: 32px;"
                                @click="openModal(arr)"
                                >
                            
                                <div class="flex-row" style="width: 100%;align-items: center;">
                                    <div class="fs-14 fw-700 ml-32" style="width: 290px;">
                                        <div class="skill-set-column">
                                            <div class="category-tag" 
                                                :class="[
                                                    getCategoryClass(arr.categoryTag),
                                                    {'category-tag-uncategorized': arr.categoryTag === 'Uncategorized'}
                                                ]"
                                                :style="{ 
                                                    backgroundColor: arr.categoryTag === 'Uncategorized' ? '#F5F5F5' : getCategoryColorLight(arr.categoryTag),
                                                    color: arr.categoryTag === 'Uncategorized' ? '#999999' : getCategoryColor(arr.categoryTag)
                                                }">
                                                {{ arr.categoryTag }}
                                            </div>
                                            <div class="skill-name">{{ arr.name }}</div>
                                        </div>
                                    </div>
                                    <div class="fs-14 flex-center" style="width: 180px;">
                                        <div class="progress-bar">
                                            <div class="progress-bar-fill" :style="{ width: arr.progress + '%' }"></div>
                                        </div>
                                        <div class="fs-11 ml-12">{{ arr.progress }}%</div>    
                                    </div>
                                    <div style="width: 100px;">
                                        <div class="initiated-tag" :class="arr.initiated.toLowerCase() === 'self' ? 'self-tag' : 'manager-tag'">
                                            {{ arr.initiated }}
                                        </div>
                                    </div>
                                    <div class="fs-13" style="width: 120px;">
                                        <div class="flex-center">
                                            <img 
                                                v-if="arr.pic || arr.members"
                                                :src="arr.pic || getDefaultAvatar(arr.members)" 
                                                class="avatar"
                                                :class="[ blurMode ? 'blurelement' : '', 'image-skeleton']"
                                                alt="User avatar"
                                            />
                                            <div class="fs-13 ml-8" :class="[ blurMode ?  'blurelement': '' ]">{{ arr.members ? arr.members.split(' ')[0] + ' ' + (arr.members.split(' ')[1] ? arr.members.split(' ')[1][0] : '') : '' }}</div>
                                        </div>
                                    </div>
                                    <div class="fs-13" style="width: 110px;">{{ convertDate(arr.date) }}</div>
                                    <div style="width: 25px;" class="expand-icon-container">
                                        <img
                                        :src="$utils('icons', 'Ic_read')"
                                        style="height: 24px;width: 24px; cursor: pointer;"
                                        class="ml-12 expand-icon"
                                        @click.stop="openModal(arr)"
                                        />
                                    </div>

                                </div>
                                
                            </div>



                        </div>

                        </div>

                        <!-- Load more indicator -->
                        <div v-if="loadingMore" class="load-more-indicator">
                            <div class="loading-dots">
                                <div class="loading-dot"></div>
                                <div class="loading-dot"></div>
                                <div class="loading-dot"></div>
                    </div>
                            <div class="loading-text">Loading more items...</div>
                </div>
               
                        <!-- End of list message -->
                        <div v-if="!hasMoreItems && visibleLearningProgress.length > 0 && hasLoadedMore" class="end-of-list">
                            <div class="end-of-list-line"></div>
                            <div class="end-of-list-text">End of list</div>
                            <div class="end-of-list-line"></div>
                        </div>
                        
                        <!-- Empty state message -->
                        <div v-if="visibleLearningProgress.length === 0 && !loading" class="empty-state">
                            <div class="empty-state-message">No learning journeys found matching your filters.</div>
                        </div>
                    </div>
                </div>
               
            </div>


            <el-dialog id="learning-journeys-dialog" :visible.sync="detailsModal" width="922px" height="847px" top="8vh"> 
                    <div class="flex-center" style="background-color:#F8F8F8;">
                        <div class="modal-1" style="width:402px;">
                            <div class="flex-column">
                                <div class="fs-18 fw-700 mt-32 fc-000000">{{ card.name }}</div>
                                <div>
                                    <div class="flex-row-between" style="margin-top: 27px;">
                                        <div class="flex-row" style="align-items: center;">
                                            <div class="fs-11" style="background: var(--unnamed-color-e6e7e8) 0% 0% no-repeat padding-box;
                                                background: #e6e7e8 0% 0% no-repeat padding-box;
                                                border-radius: 3px;padding: 4px 8px;
                                                "
                                                :class="[ blurMode ?  'blurelement': '' ]">{{ card.members_name }}</div>
                                            <div class="fs-12 pl-12">{{ card.date_show }}</div>
                                        </div>
                                        <div class="fs-12">{{ data_detail.length }} cards</div>
                                    </div>
                                </div>


                                <div class="mt-15">
                                    <div v-for="(arr,index) in data_detail" :key="`detail_index_${index}`" style="width: 322px;">
                                   
                                        <div class="card-detail" @click="onClickCard(arr)" 
                                            :class="{ 
                                                'card-detail-active': arr.focus,
                                                'card-completed': arr.status === 'completed',
                                                'card-in-progress': arr.status === 'in-progress',
                                                'card-not-started': arr.status === 'not-started'
                                            }">
                                            <div class="flex-row-between" style="align-items: center;height: 100%;">
                                                <div class="fs-16 fw-700 pl-14">{{arr.title}}</div>
                                                <div class="flex-row" style="align-items: center;">
                                                    <div class="card-status-indicator" v-if="arr.status === 'completed'">
                                                        <img :src="$utils('icons', 'ic_completed')" style="height: 18px;width: 18px;" />
                                                    </div>
                                                    <div class="card-status-indicator in-progress" v-else-if="arr.status === 'in-progress'">
                                                        <div class="progress-dot"></div>
                                                    </div>
                                                    <div class="fs-16 fw-700 pr-14">{{index+1}}</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>


                        <div class="modal-2" style="width: 510px;">
                            <div class="flex-column" style="margin-top: 59px;">
                                <div class="content-card">
                                    <div class="content-card-header">
                                        <div class="header-text">{{ card.name }}</div>
                                    </div>
                                    
                                    <div class="content-card-body">
                                        <div class="header-text">{{ data_detail_selected.title }}</div>
                                        <div class="content-text" v-html="data_detail_selected.body"></div>
                                        
                                        <div class="instruction-box" v-if="data_detail_selected.nudge">
                                            {{ data_detail_selected.nudge }}
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-dialog>
               
            <!-- Top Learners Modal -->
            <el-dialog 
                id="top-learners-modal" 
                :visible.sync="topLearnersModal" 
                width="850px"
                :show-close="true"
                :close-on-click-modal="true"
                custom-class="top-learners-dialog">
                <div slot="title" class="modal-title">
                    <span>Top Learners</span>
                </div>
                <div class="top-learners-modal-content">
                    <div class="learners-header">
                        <div class="learners-explanation">
                            Team members who have participated in the most learning journeys during the selected time period
                        </div>
                        <div class="top-learners-search">
                            <el-input
                                placeholder="Search member"
                                v-model="learnersSearch"
                                clearable
                                prefix-icon="el-icon-search"
                                size="small">
                            </el-input>
                        </div>
                    </div>
                    
                    <div class="top-learners-list-container">
                        <div class="top-learners-list">
                            <div v-for="learner in paginatedLearners" :key="learner.email" class="top-learner-row">
                                <div class="top-learner-rank-modal">{{ findLearnerRank(learner) }}</div>
                                <div class="top-learner-info-modal">
                                    <img 
                                        :src="learner.pic || getDefaultAvatar(learner.name)" 
                                        class="top-learner-avatar-modal"
                                        :class="[ blurMode ?  'blurelement': '' ]"
                                        alt="Learner avatar"
                                    />
                                    <div class="top-learner-details">
                                        <div class="top-learner-name-modal" :class="[ blurMode ?  'blurelement': '' ]">{{ learner.name }}</div>
                                        <div class="top-learner-count-modal">{{ learner.count }} {{ learner.count === 1 ? 'Journey' : 'Journeys' }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="filteredLearners.length === 0" class="no-results">
                                No learners found matching your search.
                            </div>
                        </div>
                    </div>
                    
                    <div class="modal-footer" v-if="filteredLearners.length > 0">
                        <div class="total-count">Total: {{ filteredLearners.length }} {{ filteredLearners.length === 1 ? 'Learner' : 'Learners' }}</div>
                        <div class="pagination-container">
                            <el-pagination
                                @current-change="handlePageChange"
                                :current-page.sync="currentPage"
                                :page-size="pageSize"
                                layout="prev, pager, next"
                                :total="filteredLearners.length">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </el-dialog>

            <!-- Category Analytics Modal -->
            <el-dialog 
                id="category-analytics-modal" 
                :visible.sync="categoryAnalyticsModal" 
                width="900px"
                :show-close="true"
                :close-on-click-modal="true"
                custom-class="category-analytics-dialog"
                :key="`analytics-modal-${currentPeriod}-${totalJourneyCount}`">
                <div slot="title" class="modal-title">
                    <div class="modal-header">
                        <div class="modal-title-text">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 8px;">
                                <rect x="3" y="10" width="3" height="10" rx="1" fill="#6C30CC"/>
                                <rect x="9" y="5" width="3" height="15" rx="1" fill="#6C30CC"/>
                                <rect x="15" y="2" width="3" height="18" rx="1" fill="#6C30CC"/>
                                <path d="M3 21H21" stroke="#6C30CC" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                            <span>Skill Category Analytics</span>
                        </div>
                        <div class="modal-subtitle">Distribution of learning journeys by skill category</div>
                    </div>
                </div>
                <div class="category-analytics-modal-content">
                    <div class="analytics-header">
                        <div class="analytics-time-display">
                            <span class="time-label">Time Period:</span>
                            <span class="time-value">{{ list_month_select }}</span>
                        </div>
                        <div class="analytics-actions">
                            <div class="analytics-search">
                                <el-input
                                    placeholder="Search category"
                                    v-model="categorySearch"
                                    clearable
                                    prefix-icon="el-icon-search"
                                    size="small">
                                </el-input>
                            </div>
                            <svg
                                @click="exportCategoryAnalytics()"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                class="icon-export"
                            >
                                <path
                                    fill="currentColor"
                                    d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
                                />
                            </svg>
                        </div>
                    </div>
                    
                    <div class="analytics-summary">
                        <div class="summary-card">
                            <div class="summary-value">{{ filteredCategories.length }}</div>
                            <div class="summary-label">Categories</div>
                        </div>
                        <div class="summary-card">
                            <div class="summary-value">{{ totalJourneyCount }}</div>
                            <div class="summary-label">Total Journeys</div>
                        </div>
                        <div class="summary-card">
                            <div class="summary-value">{{ (allCategories || []).reduce((total, cat) => total + (cat && cat.active ? cat.active : 0), 0) }}</div>
                            <div class="summary-label">Active</div>
                        </div>
                        <div class="summary-card">
                            <div class="summary-value">{{ (allCategories || []).reduce((total, cat) => total + (cat && cat.completed ? cat.completed : 0), 0) }}</div>
                            <div class="summary-label">Completed</div>
                        </div>
                    </div>
                    
                    <div class="analytics-main">
                        <div class="analytics-category-header">
                            <div class="header-item" style="width: 320px">Category</div>
                            <div class="header-item" style="width: 230px">Distribution</div>
                            <div class="header-item" style="width: 70px">Active</div>
                            <div class="header-item" style="width: 70px">Completed</div>
                            <div class="header-item" style="width: 70px">Total</div>
                        </div>
                        
                        <div class="analytics-list-container">
                            <div class="analytics-list">
                                <div v-for="category in filteredCategories" :key="category.category" class="category-row">
                                    <div class="category-info" style="width: 320px">
                                        <div class="category-dot" :style="getCategoryDotStyle(category.category)"></div>
                                        <div class="category-name-modal">{{ category.category }}</div>
                                    </div>
                                    <div class="category-progress-container-modal" style="width: 230px">
                                        <div class="category-progress-bar-modal">
                                            <div class="category-progress-fill-modal" 
                                                :style="{ 
                                                    width: getRelativeWidth(category.count),
                                                    backgroundColor: getCategoryColor(category.category)
                                                }">
                                            </div>
                                        </div>
                                        <div class="category-progress-label-modal">{{ (category.count / totalJourneyCount * 100).toFixed(1) }}%</div>
                                    </div>
                                    <div class="category-active-count" style="width: 70px">{{ category.active }}</div>
                                    <div class="category-completed-count" style="width: 70px">{{ category.completed }}</div>
                                    <div class="category-total-count" style="width: 70px">{{ category.count }}</div>
                                </div>
                                <div v-if="filteredCategories.length === 0" class="no-results">
                                    No categories found matching your search.
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="modal-footer" v-if="filteredCategories.length > 0">
                        <div class="total-count">Showing {{ filteredCategories.length }} {{ filteredCategories.length === 1 ? 'category' : 'categories' }}</div>
                    </div>
                </div>
            </el-dialog>

            <download-progress :active="showSnackbar"></download-progress>
        
    </div>
    
    
</template>
  
  <script>
  import Chart from "chart.js/auto";
  import format from 'date-fns/format'
  import subMonths from 'date-fns/sub_months'
  import subYears from 'date-fns/sub_years'
  import _ from 'lodash'
  
  export default {
    name: "learning-journeys",
    components: {
      loadingEven: require("../even/loading").default,
      downloadProgress: require("../even/download-progress").default,
    },
    created() {
        this.$store.dispatch("learningJourneys/getLearningJourneys");
        // Fetch teams data as soon as component is created
        this.$store.dispatch("team/getTeamsOptionsFixed", this.user);
    },
    watch: {
        pieChart() {
            this.destroyAndCreatePieChart();
        },
        barChart(){
            this.destroyAndCreateBarChart();
        },
        inputSearch: {
            handler(newVal) {
                this.$store.dispatch("learningJourneys/searchdatatable", newVal)
            },
            deep: true
        },
        // Watch optionsTeam to set selectTeam when teams are loaded
        optionsTeam: {
            handler(newVal) {
                if (newVal.length > 0 && this.selectTeam === "") {
                    this.selectTeam = this.user.user_type === "leadership" ? this.user.team : "all";
                    this.$store.dispatch("learningJourneys/changeTeam", this.selectTeam);
                }
            },
            immediate: true
        },
        // Reset visible items when data changes
        learningprogress: {
            handler() {
                this.visibleItemsCount = this.initialVisibleItems;
                this.hasLoadedMore = false; // Reset when data changes
                this.$nextTick(() => {
                    this.checkIfMoreItemsNeeded();
                });
            }
        },
        // Watch for period changes from store to sync with UI
        '$store.state.learningJourneys.period': {
            handler(newPeriod) {
                const periodMap = {
                    'all_time': 'All-time',
                    'past_year': 'Past year', 
                    'past_6_months': 'Past 6-months',
                    'past_3_months': 'Past 3-months'
                };
                if (periodMap[newPeriod] && this.list_month_select !== periodMap[newPeriod]) {
                    this.list_month_select = periodMap[newPeriod];
                }
            },
            immediate: true
        }
    },
    computed: {
        blurMode() {
            return this.$store.getters["demomode/blurMode"];
        },
        optionsTeam() {
            return this.$store.getters["team/teamsfixedall"];
        },
        user() {
            return this.$store.getters["authen/user"];
        },
        overview(){
            return this.$store.getters["learningJourneys/overview"];
        },
        pieChart(){
            return this.$store.getters["learningJourneys/pieChart"];
        },
        barChart(){
            return this.$store.getters["learningJourneys/barChart"];
        },
        learningprogress(){
            return this.$store.getters["learningJourneys/datatable"];
        },
        loading(){
            return this.$store.getters["learningJourneys/loading"];
        },
        topSixLearners() {
            return this.$store.getters["learningJourneys/topSixLearners"];
        },
        allTopLearners() {
            // Return all top learners (no limit) - used in the modal
            return this.$store.getters["learningJourneys/topLearners"];
        },
        filteredLearners() {
            const allLearners = this.allTopLearners;
            const search = this.learnersSearch.toLowerCase();
            
            if (search === '') {
                return allLearners;
            }
            
            return allLearners.filter(learner => 
                learner.name.toLowerCase().includes(search)
            );
        },
        paginatedLearners() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.filteredLearners.slice(start, end);
        },
        uniqueCategories() {
            const categories = this.learningprogress.map(item => item.categoryTag);
            return [...new Set(categories)].sort();
        },
        // Compute only the visible items to render
        visibleLearningProgress() {
            return this.learningprogress.slice(0, this.visibleItemsCount);
        },
        // Calculate if there are more items to load
        hasMoreItems() {
            return this.visibleItemsCount < this.learningprogress.length;
        },
        topSixCategories() {
            return this.$store.getters["learningJourneys/topSixCategories"];
        },
        allCategories() {
            return this.$store.getters["learningJourneys/categoryAnalytics"];
        },
        totalJourneyCount() {
            const categories = this.allCategories || [];
            return categories.reduce((total, category) => total + (category && category.count ? category.count : 0), 0) || 1; // Avoid division by zero
        },
        filteredCategories() {
            const allCategories = this.allCategories || [];
            const search = (this.categorySearch || '').toLowerCase();
            
            if (search === '') {
                return allCategories;
            }
            
            return allCategories.filter(category => 
                category && category.category && category.category.toLowerCase().includes(search)
            );
        },
        showSnackbar() {
            return this.$store.getters["learningJourneys/snackbar"];
        },
        currentPeriod() {
            return this.$store.state.learningJourneys.period;
        },
    },
    data() {
      return {
        reload:true,
        selectTeam: 'all',
        statusLearning:'In Progress',
        list_month_select: "Past 6-months",
        myChart: '',
        mybarChart: '',
        inputSearch: '',
        detailsModal:false,
        topLearnersModal: false,
        data_detail:[],
        card:{},
        data_detail_selected: [],
        learnersSearch: '',
        currentPage: 1,
        pageSize: 10,
        selectedCategory: 'All',
        // Load on scroll data
        initialVisibleItems: 10,
        visibleItemsCount: 10,
        loadMoreIncrement: 10,
        scrollThreshold: 200, // pixels from bottom to trigger load more
        loadingMore: false,
        hasLoadedMore: false,
        categoryAnalyticsModal: false,
        categorySearch: '',
      };
    },
    mounted() {
        // We've moved the team initialization to the watcher
        this.createPieChart();
        this.createBarChart();
        this.$store.dispatch("learningJourneys/getLearningJourneys");
        
        // Add scroll event listener
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        // Clean up event listener
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        // Handle scroll event to load more items
        handleScroll() {
            this.checkIfMoreItemsNeeded();
        },
        
        // Check if we need to load more items
        checkIfMoreItemsNeeded() {
            if (this.loadingMore || !this.hasMoreItems) return;
            
            const scrollPosition = window.scrollY + window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            
            if (documentHeight - scrollPosition < this.scrollThreshold) {
                this.loadMoreItems();
            }
        },
        
        // Load more items
        loadMoreItems() {
            this.loadingMore = true;
            this.hasLoadedMore = true; // Mark that we've loaded more items
            
            // Simple timeout to avoid blocking the UI
            setTimeout(() => {
                this.visibleItemsCount += this.loadMoreIncrement;
                this.loadingMore = false;
                
                // Check again in case we need to load even more
                this.$nextTick(() => {
                    this.checkIfMoreItemsNeeded();
                });
            }, 100);
        },
        convertDate(date) {
            if (!date) return '';
            
            // Split the date string to separate date and time parts
            const dateParts = date.split(' ');
            const dateStr = dateParts[0];
            const timeStr = dateParts.length > 1 ? dateParts[1] : '';
            
            // Parse the date
            const dateObj = new Date(dateStr);
            const today = new Date();
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);
            
            // Format the date based on when it occurred
            if (format(dateObj, 'YYYY-MM-DD') === format(today, 'YYYY-MM-DD')) {
                return `Today at ${timeStr.substring(0, 5)}`;
            } else if (format(dateObj, 'YYYY-MM-DD') === format(yesterday, 'YYYY-MM-DD')) {
                return `Yesterday at ${timeStr.substring(0, 5)}`;
            } else {
                // For older dates, show month and day without year
                const formattedDate = format(dateObj, 'MMM DD');
                return timeStr ? `${formattedDate} at ${timeStr.substring(0, 5)}` : formattedDate;
            }
        },
        onClickCard(arr){
            //console.log('onClickCard',arr)
            this.data_detail_selected=arr
            for(let i=0;i<this.data_detail.length;i++){
                this.data_detail[i].focus=false
            }
            arr.focus=true
        },
        openModal(arr){
            //console.log('openModal',arr)
            const arr_value=_.cloneDeep(arr)
            arr_value.date_show=format(arr.date,'MMM DD, YYYY')
            const datadetail=JSON.parse(arr.response)
            //console.log('datadetail',datadetail.cards)
            
            // Calculate the journey's overall progress percentage
            const overallProgress = arr.progress || 0;
            const totalCards = datadetail.cards.length;
            
            // Determine how many cards are completed based on the progress
            const completedCardCount = Math.floor((overallProgress / 100) * totalCards);
            
            // Mark cards as completed or in progress based on overall progress
            for(let i=0; i < datadetail.cards.length; i++){
                datadetail.cards[i].focus = false;
                
                // Mark cards as completed, in progress, or not started
                if (i < completedCardCount) {
                    datadetail.cards[i].status = 'completed';
                } else if (i === completedCardCount && overallProgress > 0 && overallProgress < 100) {
                    datadetail.cards[i].status = 'in-progress';
                } else {
                    datadetail.cards[i].status = 'not-started';
                }
            }
            
            datadetail.cards[0].focus = true;
            this.data_detail = datadetail.cards;
            this.data_detail_selected = datadetail.cards[0];
            this.card = arr_value;
            this.detailsModal = true;
        },

        closeModal(){
            this.detailsModal=false
        },
        destroyAndCreatePieChart() {
            if (this.myChart) {
                this.myChart.destroy();
                this.myChart = null;
            }
            this.$nextTick(() => {
                this.createPieChart();
            });
        },
        destroyAndCreateBarChart() {
            if (this.mybarChart) {
                this.mybarChart.destroy();
                this.mybarChart = null;
            }
            this.$nextTick(() => {
                this.createBarChart();
            });
        },
        changeTime(val){
            this.list_month_select = val;
            //console.log('changeTime')
            this.$store.dispatch("learningJourneys/filterPeriod", val)
        },
        handleTeams(val){
            this.selectTeam = val;
            //('handleTeams')
            this.$store.dispatch("learningJourneys/changeTeam", val)
        },
        createPieChart() {
        //console.log('createChart')
        // console.log('this.datachart',this.datachart)
        var pieChart = this.$refs.pieChart;
        

        if (pieChart) {
            const data = {

            datasets: [{
                label: 'Rating overview',
                data:[this.pieChart?this.pieChart.manager:0, this.pieChart?this.pieChart.self:0],
                backgroundColor: [
                '#32C2D5',
                '#6C30CC',
                
               
                ],
                hoverOffset: 6
            }],
            };
            this.myChart = new Chart(pieChart, {
            type: "pie",
            data:data ,
                });
            }
            },
        createBarChart(){
            //console.log('createBarChart',this.barChart)
            var barChart = this.$refs.barChart;
            const month = []
            const self = []
            const manager = []
                if(this.list_month_select=='All-time'){
                    for(let i=0;i<12;i++){
                        month.unshift(format(subMonths(new Date(), i), 'MMM'))
                        const month_bar = format(subMonths(new Date(), i), 'YYYY-MM')
                        
                        if(this.barChart&&this.barChart[month_bar]){
                            self.unshift(this.barChart[month_bar].self)
                            manager.unshift(this.barChart[month_bar].manager)
                        }else{
                            self.unshift(0)
                            manager.unshift(0)
                        }

                    }
                
                }else if(this.list_month_select=='Past year'){
                    for(let i=0;i<12;i++){
                        const past_year = format(subYears(new Date(), 1), 'YYYY-12')
                        const past_year_bar = format(subMonths(past_year, i), 'YYYY-MM')
                        //console.log('past_year_bar',past_year_bar)
                        month.unshift(format(subMonths(new Date(past_year), i), 'YYYY-MMM'))
                        const month_bar = format(subMonths(new Date(past_year), i), 'YYYY-MM')
                        if(this.barChart&&this.barChart[month_bar]){
                            self.unshift(this.barChart[month_bar].self)
                            manager.unshift(this.barChart[month_bar].manager)
                        }else{
                            self.unshift(0)
                            manager.unshift(0)
                        }

                    }
                    
                }else if(this.list_month_select=='Past 6-months'){
                    for(let i=0;i<6;i++){
                        month.unshift(format(subMonths(new Date(), i), 'MMM'))
                        const month_bar = format(subMonths(new Date(), i), 'YYYY-MM')
                        
                        if(this.barChart&&this.barChart[month_bar]){
                            self.unshift(this.barChart[month_bar].self)
                            manager.unshift(this.barChart[month_bar].manager)
                        }else{
                            self.unshift(0)
                            manager.unshift(0)
                        }

                    }
                }else if(this.list_month_select=='Past 3-months'){
                    
                    for(let i=0;i<3;i++){
                        month.unshift(format(subMonths(new Date(), i), 'MMM'))
                        const month_bar = format(subMonths(new Date(), i), 'YYYY-MM')
                        if(this.barChart&&this.barChart[month_bar]){
                            self.unshift(this.barChart[month_bar].self)
                            manager.unshift(this.barChart[month_bar].manager)
                        }else{
                            self.unshift(0)
                            manager.unshift(0)
                        }

                    }
                }
            //console.log('month',month)
            if (barChart) {
                const data = {
                    labels: month,
                    datasets: [{
                        label: 'Manager',
                        data: manager,
                        backgroundColor: '#32C2D5',
                        borderColor: '#32C2D5',
                        borderWidth: 1
                    },{
                        label: 'Self',
                        data: self,
                        backgroundColor: '#6C30CC',
                        borderColor: '#6C30CC',
                        borderWidth: 1
                    }]
                };
                this.mybarChart = new Chart(barChart, {
                    type: 'bar',
                    data: data,
                    options: {
                        plugins: {
                            legend: {
                                display: false 
                            }
                        },
                        scales: {
                            y: {
                                min: 0,
                                
                                grid: {
                                    borderDash: [5, 5], 
                                    drawBorder: false,  
                                    color: 'rgba(0, 0, 0, 0.1)' 
                                },
                                ticks: {
                                    callback: function(value, index, ticks) {
                                        if (value === 0 || value === Math.max(...ticks.map(t => t.value))) {
                                            return value;
                                        }
                                        return '';
                                    }
                                },
                                
                            },
                            x: {
                                grid: {
                                    display: false 
                                }
                            }

                        }
                    }
                });
            }
        },
        changeStatus(val){
            this.statusLearning = val;
            //console.log('changeStatus')
            this.$store.dispatch("learningJourneys/filterStatus", val)
        },
        getDefaultAvatar(name = '') {
            // Extract initials from the name
            const initials = name
                .split(' ')
                .map(part => part.charAt(0))
                .join('')
                .toUpperCase()
                .substring(0, 2) || 'U';
            
            // Create SVG for the avatar
            const backgroundColor = '5C21E0'; // Purple background
            const svg = `
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                <rect width="40" height="40" fill="#${backgroundColor}"/>
                <text x="50%" y="50%" dy=".1em" fill="white" font-family="Lato, sans-serif" 
                        font-size="16" font-weight="normal" text-anchor="middle" dominant-baseline="middle">
                    ${initials}
                </text>
                </svg>
            `;
            
            // Convert SVG to a data URL
            const dataUrl = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
            return dataUrl;
        },
        openTopLearnersModal() {
            this.topLearnersModal = true;
        },
        handlePageChange(newPage) {
            this.currentPage = newPage;
        },
        findLearnerRank(learner) {
            const allLearners = this.allTopLearners;
            const sortedLearners = [...allLearners].sort((a, b) => b.count - a.count);
            const rank = sortedLearners.findIndex(l => l.email === learner.email) + 1;
            return rank;
        },
        changeCategory(category) {
            this.selectedCategory = category;
            this.$store.dispatch("learningJourneys/filterByCategory", category);
        },
        getCategoryClass(category) {
            // Just return a generic class since we're using inline styles for colors
            return 'category-tag-dynamic';
        },
        openCategoryAnalyticsModal() {
            this.categoryAnalyticsModal = true;
        },
        handleCategoryPageChange(newPage) {
            this.categoryPage = newPage;
        },
        getCategoryColor(category) {
            // If uncategorized, return a neutral gray
            if (category === 'Uncategorized') {
                return '#94A3B8';  // Slate gray - more modern than pure gray
            }
            
            // Modern color palette that complements the brand purple (#6C30CC)
            const colorPalette = [
                '#6C30CC', // Brand purple - Primary
                '#00A3B4', // Teal - Fresh and modern
                '#FF6B6B', // Coral - Energetic
                '#4ECDC4', // Mint - Calming
                '#45B7D1', // Sky blue - Professional
                '#FF8F5E', // Peach - Warm
                '#9D8DF1', // Lavender - Complementary to primary
                '#4CAF50', // Green - Success/Growth
                '#FF5252', // Red - Important
                '#FFC107', // Amber - Warning/Active
                '#26C6DA', // Cyan - Info
                '#FF7043', // Deep Orange - Attention
                '#78909C', // Blue Gray - Neutral
                '#7986CB', // Indigo - Professional
                '#29B6F6', // Light Blue - Friendly
                '#F06292', // Pink - Creative
                '#26A69A', // Teal variant - Calming
                '#AB47BC', // Purple variant - Related to brand
                '#5C6BC0', // Indigo variant - Professional
                '#EC407A'  // Pink variant - Energetic
            ];
            
            // Generate a consistent hash of the category name to use as an index
            let hash = 0;
            for (let i = 0; i < category.length; i++) {
                hash = ((hash << 5) - hash) + category.charCodeAt(i);
                hash = hash & hash; // Convert to 32bit integer
            }
            
            // Use the absolute hash value modulo the palette length to get an index
            const colorIndex = Math.abs(hash) % colorPalette.length;
            
            // Return the color at that index
            return colorPalette[colorIndex];
        },
        getCategoryDotStyle(category) {
            return {
                backgroundColor: this.getCategoryColor(category)
            };
        },
        // Method to calculate relative widths for the progress bars
        getRelativeWidth(count) {
            const maxCount = Math.max(...this.allCategories.map(c => c.count));
            // Use logarithmic scale to make small values more visible
            // Ensure bars are at least 15% wide for better visibility
            const minWidth = 15;
            const width = maxCount > 0 ? 
                Math.max(minWidth, Math.log(count + 1) / Math.log(maxCount + 1) * 100) : 
                minWidth;
            return `${width}%`;
        },

        // Method to get lighter version of the color for backgrounds
        getCategoryColorLight(category) {
            const color = this.getCategoryColor(category);
            // Use a very light transparency for backgrounds
            return this.hexToRGBA(color, 0.12);  // Reduced from 0.2 to 0.12 for subtler backgrounds
        },

        // Helper to convert hex color to rgba with transparency
        hexToRGBA(hex, alpha = 1) {
            const r = parseInt(hex.slice(1, 3), 16);
            const g = parseInt(hex.slice(3, 5), 16);
            const b = parseInt(hex.slice(5, 7), 16);
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        },

        // Export Category Analytics data
        exportCategoryAnalytics() {
            try {
                this.$store.dispatch("learningJourneys/getDataExportCategoryAnalytics");
            } catch (error) {
                console.error('Error initiating export:', error);
                // Could add user notification here
            }
        }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .txtOption {
  color: #4a4a4a;
  font-size: 14px;
  margin-left: 16px;
  width: 158px;
  display: inline-block;
}

.menu-option-style {
  border-bottom: transparent;
  background: #f4f4f4;
  border-radius: 4px;
}
  #menuDropdownType .el-submenu__title {
  height: 40px;
  line-height: 40px;
  background-color: #f4f4f4;
}
.card-style{
    width: 210px;
    height: 72px;
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #0000001F;
    border-radius: 4px;
    opacity: 1;
}

.card-style-content-green-icon{
    margin-left: 12px;
    width: 48px;
    height: 48px;
    background: #DCFCE7 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
}
.card-style-content-pink-icon{
    margin-left: 12px;
    width: 48px;
    height: 48px;
    background: #FEE2E2 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
}
.card-style-content-yellow-icon{
    margin-left: 12px;
    width: 48px;
    height: 48px;
    background: #FEF9C3 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
}
.label-pie{
    width: 16px;
    height: 16px;
    background: var(--unnamed-color-32c2d5) 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 0.8;
}
.card-layer {
    box-shadow: 0px 1px 4px #00000029;
    border-radius: 9px;
    padding: 0 4px;
    font-size: 13px;
    height: 64px;
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    width: 100%;
    padding: 0;
    position: absolute;
    background: #FCFAFF 0% 0% no-repeat padding-box;
    transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    opacity: 1;
}

.relative {
    position: relative;
    cursor: pointer;
}

.relative:hover .card-layer:nth-child(1) {
    transform: translateY(-8px);
    opacity: 0.9;
}

.relative:hover .card-layer:nth-child(2) {
    transform: translateY(-4px);
    opacity: 0.95;
}

.relative:hover .card-layer:nth-child(3) {
    transform: translateY(-1px) scale(1.01);
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);
    background: #F7F3FF 0% 0% no-repeat padding-box;
    cursor: pointer;
}

.relative:active .card-layer:nth-child(1) {
    transform: translateY(-4px);
}

.relative:active .card-layer:nth-child(2) {
    transform: translateY(-2px);
}

.relative:active .card-layer:nth-child(3) {
    transform: translateY(0) scale(1);
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
}

.card {
  position: relative;
  height: 100px
}
.progress-bar{
    width:125px;
    height: 10px;
    position: relative;
    background-color: #00000015;
    border-radius: 4px;
}
.progress-bar-fill{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background-color: #6C30CC;
    border-radius: 4px;
}
.avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
}
.modal-1{
    overflow-y: scroll;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 0px 40px 40px 0px;
    opacity: 1;
    height: 84vh;
    min-height: 847px;
    padding-left: 40px;
    padding-right: 34px;
    max-height: 1200px;

}
.modal-2{
  overflow-y: scroll;
  background: #F8F8F8 0% 0% no-repeat padding-box;
  opacity: 1;
  height: 84vh;
  padding-left: 42px;
  padding-right: 42px;
  min-height: 847px;
  max-height: 1200px;
  position: relative;
}
.card-detail{
    width: 322px;
    height: 60px;
    cursor: pointer;
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 4px #00000029;
    border-radius: 9px;
    opacity: 1;
    border: 1px solid transparent;
    transition: all 0.3s ease; 
    margin-bottom: 14px;
    position: relative;
    overflow: hidden;
    
    &:hover {
        border-color: #6C30CC;
    }

    &.card-detail-active {
        border: 1px solid #6C30CC !important;
    }
    
    &.card-completed {
        border-left: 4px solid #4CAF50;
        
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: rgba(76, 175, 80, 0.05);
            z-index: 0;
        }
    }
    
    &.card-in-progress {
        border-left: 4px solid #FFC107;
        
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: rgba(255, 193, 7, 0.05);
            z-index: 0;
        }
    }
    
    &.card-not-started {
        opacity: 0.8;
    }
}

.card-status-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    
    &.in-progress {
        .progress-dot {
            width: 8px;
            height: 8px;
            background-color: #FFC107;
            border-radius: 50%;
            animation: pulse 1.5s infinite;
        }
    }
}

@keyframes pulse {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.7);
    }
    
    70% {
        transform: scale(1);
        box-shadow: 0 0 0 6px rgba(255, 193, 7, 0);
    }
    
    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
    }
}

.box_text{
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    opacity: 1;

}

/* Learning Content Card Styles */
.content-card {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0px 3px 6px rgba(0,0,0,0.1);
  margin-bottom: 24px;
}

.content-card-header {
  background-color: #6C30CC;
  color: white;
  display: flex;
  align-items: center;
  padding: 16px 24px;
}

.header-text {
  font-size: 18px;
  font-weight: 700;
  flex: 1;
}

.content-card-body {
  background-color: #eeeaf6;
  color: #000;
  padding: 24px;
  display: flex;
  flex-direction: column;
//   gap: 20px;
}
.content-card-body .content-text{
    font-size: 15px;
    font-weight: 400;
    color: #000;
    padding: 12px 0 24px 0;
    word-break: break-word;
}

.instruction-box {
  background-color: #FFF8C7;
  border-radius: 12px;
  padding: 16px 20px;
  font-size: 16px;
  color: #000;
  font-weight: 500;
  word-break: break-word;
}

.rating-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
}

.rating-btn {
  padding: 10px 16px;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  flex: 1;
  margin: 0 8px;
}

.too-basic {
  background-color: #F2F2F2;
}

.just-right {
  background-color: #F2F2F2;
}

.too-advanced {
  background-color: #F2F2F2;
}

.rating-btn:hover {
  opacity: 0.9;
}

.initiated-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
}

.self-tag {
  background-color: #6C30CC;
  color: white;
}

.manager-tag {
  background-color: #32C2D5;
  color: white;
}

.compact-section {
  background: #F7F7F7 0% 0% no-repeat padding-box;
  border-radius: 24px;
  opacity: 1;
  padding: 16px 24px;
}

.section-subtitle {
  color: var(--unnamed-color-000000);
  opacity: 0.6;
}

.top-learners-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 12px;
}

.top-learner-item {
  position: relative;
  background: #FFFFFF;
  border-radius: 16px;
  padding: 12px;
  box-shadow: 0px 1px 4px rgba(0,0,0,0.1);
  height: 60px;
  display: flex;
  align-items: center;
}

.learner-rank {
  position: absolute;
  top: -8px;
  left: -8px;
  background: #6C30CC;
  color: white;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 11px;
}

.learner-profile {
  margin-right: 12px;
}

.learner-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.learner-info {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.learner-name {
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #000;
}

.learner-journeys {
  font-size: 11px;
  color: #000;
}

.view-all-btn {
  color: #6C30CC;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
}

.view-all-btn:hover {
  opacity: 0.8;
}

/* Top Learners Modal Styles */
.top-learners-modal-content {
  padding: 0 16px;
}

.top-learners-explanation {
  color: #666;
  margin-bottom: 24px;
  word-break: break-word;
}

.mb-16 {
  margin-bottom: 16px;
}

.top-learners-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 500px;
  overflow-y: auto;
}

.top-learner-row {
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0px 1px 4px rgba(0,0,0,0.1);
  position: relative;
}

.top-learner-row:hover {
  transform: translateY(-2px);
  box-shadow: 0px 3px 6px rgba(0,0,0,0.1);
}

.top-learner-rank-modal {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #6C30CC;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  margin-right: 12px;
}

.top-learner-info-modal {
  display: flex;
  align-items: center;
  flex: 1;
}

.top-learner-avatar-modal {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 12px;
  border: 1px solid #f0f0f0;
}

.top-learner-details {
  display: flex;
  flex-direction: column;
}

.top-learner-name-modal {
  font-size: 14px;
  font-weight: 700;
  color: #000;
}

.top-learner-count-modal {
  font-size: 13px;
  color: #666;
}

.top-learners-search {
  display: flex;
  align-items: center;
}

.no-results {
  text-align: center;
  color: #666;
  margin: 32px 0;
  font-size: 14px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.load-more-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 12px 24px;
  background-color: #f0f0f0;
  border-radius: 8px;
}

.loading-dots {
  display: flex;
  gap: 4px;
  animation: blink 1.5s infinite;
}

.loading-dot {
  width: 8px;
  height: 8px;
  background-color: #6C30CC;
  border-radius: 50%;
}

@keyframes blink {
  0% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}

.loading-text {
  margin-left: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #666;
}

.end-of-list {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 12px 24px;
  background-color: #f0f0f0;
  border-radius: 8px;
}

.end-of-list-line {
  flex: 1;
  height: 1px;
  background-color: #666;
}

.end-of-list-text {
  margin: 0 16px;
  font-size: 14px;
  font-weight: 600;
  color: #666;
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 12px 24px;
  background-color: #f0f0f0;
  border-radius: 8px;
}

.empty-state-message {
  font-size: 14px;
  font-weight: 600;
  color: #666;
}

/* Tab styling */
#top-learners-modal .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #eeeeee;
}

#top-learners-modal .el-tabs__active-bar {
  background-color: #6C30CC;
  height: 3px;
}

#top-learners-modal .el-tabs__item {
  font-size: 15px;
  color: #666;
  height: 44px;
  line-height: 44px;
}

#top-learners-modal .el-tabs__item.is-active {
  color: #6C30CC;
  font-weight: 700;
}

#top-learners-modal .el-tabs__item:hover {
  color: #6C30CC;
}

/* Scrollbar styles for the learner lists */
.top-learners-list::-webkit-scrollbar,
.top-learners-grid-view::-webkit-scrollbar {
  width: 6px;
}

.top-learners-list::-webkit-scrollbar-track,
.top-learners-grid-view::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.top-learners-list::-webkit-scrollbar-thumb,
.top-learners-grid-view::-webkit-scrollbar-thumb {
  background: #d0d0d0;
  border-radius: 10px;
}

.top-learners-list::-webkit-scrollbar-thumb:hover,
.top-learners-grid-view::-webkit-scrollbar-thumb:hover {
  background: #bbbbbb;
}

.expand-icon-container {
    position: relative;
    z-index: 2;
}

.expand-icon {
    transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    opacity: 0.8;
}

.relative:hover .expand-icon {
    transform: scale(1.15);
    opacity: 1;
}

.relative:active .expand-icon {
    transform: scale(0.95);
}

.card-layer[style*="position: relative"] {
    z-index: 1;
}

.card-layer[style*="position: relative"]::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 100%;
    background-color: rgba(108, 48, 204, 0.03);
    transition: width 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    z-index: -1;
}

.relative:hover .card-layer[style*="position: relative"]::after {
    width: 100%;
    left: 0;
    right: auto;
}

.skill-set-column {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.skill-name {
    font-weight: 700;
    line-height: 1.4;
}

.category-tag {
    display: inline-block;
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 12px;
    font-weight: normal;
    line-height: 1.4;
    width: fit-content;
    transition: all 0.2s ease;
}

.category-tag-dynamic {
    /* Generic styling that works with inline color styles */
    /* The actual colors will be set by inline styles */
    border: 1px solid transparent;
}

.category-tag-uncategorized {
    background-color: #F5F5F5;
    color: #999999;
    font-size: 10px;
    opacity: 0.8;
}

/* Hover effect for all tags except uncategorized */
.category-tag:not(.category-tag-uncategorized):hover {
    opacity: 0.9;
    transform: translateY(-1px);
}

/* Add a class to handle AI-generated categories */
.ai-generated-tag {
    position: relative;
}

.ai-generated-tag::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 12px;
    opacity: 0.1;
    pointer-events: none;
    background-image: linear-gradient(45deg, rgba(255,255,255,0.1) 25%, transparent 25%, 
                      transparent 50%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0.1) 75%, 
                      transparent 75%, transparent);
    background-size: 8px 8px;
}

// Add toolbar styling
.filter-toolbar {
    background: #F7F7F7;
    padding: 8px 16px;
    border-radius: 8px;
    margin: 8px 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    height: 32px;

    .el-menu-demo {
        background: transparent;
        border-bottom: none;
    }
}

.text-truncate {
    max-width: 260px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
}

// Override Element UI menu styles
:deep(.el-menu--horizontal) {
    border-bottom: none;
    
    .el-submenu__title {
        height: 32px;
        line-height: 32px;
        padding: 0 12px;
    }
}

:deep(.el-menu) {
    .el-menu-item {
        height: 36px;
        line-height: 36px;
        padding: 0 12px;
    }
}

.category-menu-item {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 16px !important;
}

// Make dropdown menu wider
:deep(.el-menu--popup) {
    min-width: 300px !important;
}

/* Category Analytics Styles */
.category-analytics-container {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.category-analytics-item {
    background: #FFFFFF;
    border-radius: 6px;
    padding: 8px 10px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    box-shadow: 0px 1px 3px rgba(0,0,0,0.1);
}

.category-name-wrapper {
    display: flex;
    align-items: center;
    gap: 4px;
}

.category-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
}

.category-name {
    font-size: 13px;
    font-weight: 600;
    color: #333;
    flex-grow: 1;
}

.category-count {
    font-size: 11px;
    color: #666;
}

.category-progress-container {
    display: flex;
    align-items: center;
    gap: 4px;
    margin: 2px 0;
}

.category-progress-bar {
    height: 4px;
    background-color: #EEEEEE;
    border-radius: 2px;
    flex-grow: 1;
    overflow: hidden;
}

.category-progress-fill {
    height: 100%;
    border-radius: 2px;
}

.category-progress-label {
    font-size: 11px;
    font-weight: 600;
    color: #666;
    width: 28px;
    text-align: right;
}

.category-status {
    display: flex;
    gap: 8px;
    margin-top: 2px;
}

.category-status-item {
    display: flex;
    align-items: center;
    gap: 4px;
}

.category-status-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex-shrink: 0;
}

.active-dot {
    background-color: #FFC107;
}

.completed-dot {
    background-color: #4CAF50;
}

.category-status-label {
    font-size: 10px;
    color: #666;
}

.empty-categories {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #F7F7F7;
    border-radius: 6px;
    padding: 16px;
    margin-top: 8px;
}

.empty-categories-message {
    font-size: 13px;
    color: #666;
}

/* Category Analytics Modal Styles */
.category-analytics-modal-content {
    padding: 0 16px 16px;
}

.analytics-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
    gap: 16px;
}

.analytics-time-display {
    display: flex;
    align-items: center;
    gap: 8px;
}

.time-label {
    font-size: 12px;
    color: #666;
}

.time-value {
    font-size: 14px;
    font-weight: 600;
    color: #333;
}

.analytics-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.analytics-header .icon-export {
    flex-shrink: 0;
}

.analytics-explanation {
    color: #666;
    font-size: 14px;
    max-width: 450px;
}

.analytics-search {
    width: 240px;
}

.analytics-list-container {
    margin: 16px 0;
}

.analytics-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-height: 560px;
    overflow-y: auto;
    padding-right: 8px;
}

.category-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFFFFF;
    border-radius: 6px;
    padding: 12px;
    box-shadow: 0px 1px 3px rgba(0,0,0,0.1);
}

.category-info {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 180px;
}

.category-details {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.category-name-modal {
    font-weight: 600;
    font-size: 13px;
    color: #333;
}

.category-count-modal {
    font-size: 11px;
    color: #666;
}

.category-progress-container-modal {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-grow: 1;
    padding: 0 16px;
}

.category-progress-bar-modal {
    height: 8px;
    background-color: #f0f0f0;
    border-radius: 4px;
    flex-grow: 1;
    overflow: hidden;
    max-width: 180px;
    box-shadow: inset 0 1px 2px rgba(0,0,0,0.1);
}

.category-progress-fill-modal {
    height: 100%;
    border-radius: 4px;
    transition: width 0.3s ease, background-color 0.3s ease;
    min-width: 4px; /* Ensure tiny values are still visible */
    position: relative;
    /* Add subtle gradient effect */
    background-image: linear-gradient(90deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.3) 100%);
}

.category-progress-label-modal {
    font-size: 13px;
    font-weight: 600;
    color: #666;
    width: 40px;
    text-align: right;
}

.category-stats {
    display: flex;
    gap: 12px;
    width: 120px;
}

.category-stat {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.stat-label {
    font-size: 11px;
    color: #666;
}

.stat-value {
    font-size: 14px;
    font-weight: 600;
    color: #333;
}

.analytics-icon-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: 12px;
    cursor: pointer;
    border-radius: 50%;
    transition: background 0.2s;
    padding: 4px;
    &:hover {
        background: #f3eaff;
    }
    svg {
        display: block;
    }
}
  </style>
<style lang="scss">
  #learning-journeys-dialog {
    .el-dialog {
      margin-top: 8vh !important;
      
      .el-dialog__header {
        padding: 0 !important;
      }
      
      .el-dialog__body {
        padding: 0 !important;
        height: 84vh;
        min-height: 847px;
        max-height: 1200px;
      }
    }
  }

  /* Modal styling overrides */
  #top-learners-modal {
    .el-dialog__header {
      text-align: center;
      padding: 16px 20px;
      border-bottom: 1px solid #eee;
    }

    .el-dialog__title {
      font-size: 20px;
      font-weight: 700;
      color: #000;
    }

    .el-dialog__body {
      padding: 0;
    }
    
    .el-dialog__headerbtn {
      top: 16px;
    }
    
    .el-pagination .btn-prev,
    .el-pagination .btn-next {
      color: #6C30CC;
      border-radius: 4px;
    }
    
    .el-pagination .number.active {
      color: #fff;
      background-color: #6C30CC;
    }
    
    .el-pagination .number:hover {
      color: #6C30CC;
    }
  }
  
  .top-learners-dialog {
    border-radius: 16px;
    overflow: hidden;
  }
  
  .modal-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 20px;
    font-weight: 700;
    padding: 16px 24px 0 24px;
  }
  
  .learners-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px 0;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 16px;
  }
  
  .learners-explanation {
    color: #666;
    font-size: 14px;
    max-width: 450px;
    word-break: break-word;
  }
  
  .top-learners-search {
    width: 240px;
  }
  
  .top-learners-modal-content {
    padding-bottom: 16px;
  }
  
  .top-learners-list-container {
    padding: 0 24px;
  }
  
  .top-learners-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 560px;
    overflow-y: auto;
    padding-right: 8px;
  }
  
  .top-learner-row {
    display: flex;
    align-items: center;
    background: #FFFFFF;
    border-radius: 12px;
    padding: 12px 16px;
    box-shadow: 0px 1px 3px rgba(0,0,0,0.08);
    position: relative;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
  }
  
  .top-learner-row:hover {
    transform: translateY(-2px);
    box-shadow: 0px 3px 6px rgba(0,0,0,0.1);
  }
  
  .top-learner-rank-modal {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #6C30CC;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    margin-right: 8px;
    font-size: 9px;
  }
  
  .top-learner-info-modal {
    display: flex;
    align-items: center;
    flex: 1;
  }
  
  .top-learner-avatar-modal {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 8px;
    border: 1px solid #f0f0f0;
  }
  
  .top-learner-details {
    display: flex;
    flex-direction: column;
  }
  
  .top-learner-name-modal {
    font-size: 12px;
    font-weight: 700;
    color: #000;
  }
  
  .top-learner-count-modal {
    font-size: 10px;
    color: #666;
  }
  
  .modal-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    margin-bottom: 16px;
    padding: 12px 24px 0;
    border-top: 1px solid #eee;
  }
  
  .total-count {
    font-size: 13px;
    color: #666;
  }
  
  .pagination-container {
    display: flex;
    justify-content: flex-end;
  }
  
  .no-results {
    text-align: center;
    color: #666;
    margin: 32px 0;
    font-size: 13px;
  }
</style>

<style lang="scss" scoped>
/* Update existing category analytics modal styles */
.category-analytics-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.modal-header {
  display: flex;
  gap: 4px;
  flex-direction: column;
  align-items: left;
}

.modal-title-text {
  display: flex;
  align-items: left;
  font-size: 18px;
  font-weight: 700;
  color: #333;
}

.modal-subtitle {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
}

.category-analytics-modal-content {
  padding: 0 24px 24px;
}

.analytics-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 16px 0;
  border-bottom: 1px solid #eee;
  margin-bottom: 16px;
}

.analytics-filter {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-label {
  font-size: 13px;
  color: #666;
}

.time-period-select {
  width: 150px;
}

.analytics-search {
  width: 220px;
}

.analytics-summary {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.summary-card {
  background: #f8f8f8;
  border-radius: 8px;
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.summary-value {
  font-size: 24px;
  font-weight: 700;
  color: #6C30CC;
}

.summary-label {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
}

.analytics-main {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  overflow: hidden;
}

.analytics-category-header {
  display: flex;
  background: #f4f4f4;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  text-align: left;
}

.header-item {
  display: flex;
  align-items: center;
  text-align: left;

  &[style*="width: 70px"] {
    justify-content: center;
    text-align: center;
  }
}

.analytics-list-container {
  padding: 8px 0;
  max-height: none; /* Remove height limit to show all categories */
  overflow-y: visible; /* Change from auto to visible */
}

.analytics-list {
  display: flex;
  flex-direction: column;
}

.category-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.2s;
  
  &:hover {
    background: #f9f5ff;
  }
  
  &:last-child {
    border-bottom: none;
  }
}

.category-info {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 220px;
}

.category-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.category-name-modal {
  font-weight: 600;
  font-size: 13px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.category-progress-container-modal {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-grow: 1;
  padding: 0 16px;
}

.category-progress-bar-modal {
  height: 8px;
  background-color: #f0f0f0;
  border-radius: 4px;
  flex-grow: 1;
  overflow: hidden;
}

.category-progress-fill-modal {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.category-progress-label-modal {
  font-size: 13px;
  font-weight: 600;
  color: #666;
  width: 40px;
  text-align: right;
}

.category-active-count,
.category-completed-count,
.category-total-count {
  width: 80px;
  text-align: center;
  font-size: 13px;
  color: #333;
  font-weight: 500;
}

.category-active-count {
  color: #FFC107;
}

.category-completed-count {
  color: #4CAF50;
}

.category-total-count {
  font-weight: 600;
}

.modal-footer {
  display: flex;
  justify-content: flex-start; /* Left-align the content */
  align-items: center;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #eee;
  text-align: left;
}

.total-count {
  font-size: 13px;
  color: #666;
}

.no-results {
  text-align: center;
  padding: 32px;
  color: #666;
    font-size: 14px;
  }

/* Update the analytics icon button */
.analytics-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.2s;
  padding: 6px;
  background: #f3eaff;
  
  &:hover {
    background: #e6d4ff;
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
}
</style>

<style lang="scss" scoped>
/* Update category analytics modal styles with modern look */
/* ... existing styles ... */

.category-analytics-dialog {
  border-radius: 24px !important;
  overflow: hidden;
}

.modal-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
  padding-left: 0;
}

.modal-title-text {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 700;
  color: #333;
  text-align: left;
}

.modal-subtitle {
  font-size: 14px;
  color: #666;
  margin-top: 4px;
  text-align: left;
}

.category-analytics-modal-content {
  padding: 0 24px 24px;
  text-align: left;
}

.analytics-filter {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-label {
  font-size: 14px;
  color: #666;
}

.time-period-select {
  width: 150px;
}

.analytics-search {
  width: 240px;
}

.analytics-summary {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.summary-card {
  background: #f8f8f8;
  border-radius: 16px;
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.summary-value {
  font-size: 24px;
  font-weight: 700;
  color: #6C30CC;
}

.summary-label {
  font-size: 14px;
  color: #666;
  margin-top: 4px;
}

.analytics-main {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  overflow: hidden;
}

.analytics-category-header {
  display: flex;
  background: #f4f4f4;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  text-align: left;
}

.header-item {
  display: flex;
  align-items: center;
  text-align: left;
}

.analytics-list-container {
  padding: 8px 0;
  max-height: none; /* Remove height limit to show all categories */
  overflow-y: visible; /* Change from auto to visible */
}

.analytics-list {
  display: flex;
  flex-direction: column;
}

.category-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.2s;
  
  &:hover {
    background: #f9f5ff;
  }
  
  &:last-child {
    border-bottom: none;
  }
}

.category-info {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 320px;
  text-align: left;
}

.category-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.category-name-modal {
  font-weight: 600;
  font-size: 14px;
  color: #333;
  white-space: normal;
  overflow: hidden;
  text-align: left;
}

.category-progress-container-modal {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-grow: 1;
  padding: 0 8px;
}

.category-progress-bar-modal {
  height: 8px;
  background-color: #f0f0f0;
  border-radius: 4px;
  flex-grow: 1;
  overflow: hidden;
  max-width: 180px;
}

.category-progress-fill-modal {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.category-progress-label-modal {
  font-size: 13px;
  font-weight: 600;
  color: #666;
  width: 40px;
  text-align: right;
}

.category-active-count,
.category-completed-count,
.category-total-count {
  width: 70px;
  text-align: center;
  font-size: 13px;
  color: #333;
  font-weight: 500;
}

.category-active-count {
  color: #FFC107;
}

.category-completed-count {
  color: #4CAF50;
}

.category-total-count {
  font-weight: 600;
}

.modal-footer {
  display: flex;
  justify-content: flex-start; /* Left-align the content */
  align-items: center;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #eee;
  text-align: left;
}

.total-count {
  font-size: 13px;
  color: #666;
  text-align: left;
}

.no-results {
  text-align: center;
  padding: 32px;
  color: #666;
  font-size: 14px;
}

/* Update Element UI Modal style */
:deep(.el-dialog__header) {
  padding: 20px 24px 0 !important;
  text-align: left !important;
}

:deep(.el-dialog__title) {
  text-align: left !important;
  font-weight: 700;
}

:deep(.el-dialog__body) {
  padding: 20px 0 !important;
}

:deep(.el-dialog) {
  border-radius: 24px !important;
  overflow: hidden;
}

:deep(.el-dialog__headerbtn) {
  top: 16px;
  right: 16px;
}
</style>

<style lang="scss" scoped>
/* Update category analytics modal styles with modern look */
/* ... existing styles ... */

.category-analytics-dialog {
  border-radius: 24px !important;
  overflow: hidden;
}

.modal-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
  padding-left: 0;
}

.modal-title-text {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 700;
  color: #333;
  text-align: left;
}

.modal-subtitle {
  font-size: 14px;
  color: #666;
  margin-top: 4px;
  text-align: left;
}

.category-analytics-modal-content {
  padding: 0 24px 24px;
  text-align: left;
}

.analytics-filter {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-label {
  font-size: 14px;
  color: #666;
}

.time-period-select {
  width: 150px;
}

.analytics-search {
  width: 240px;
}

.analytics-summary {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.summary-card {
  background: #f8f8f8;
  border-radius: 16px;
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.summary-value {
  font-size: 24px;
  font-weight: 700;
  color: #6C30CC;
}

.summary-label {
  font-size: 14px;
  color: #666;
  margin-top: 4px;
}

.analytics-main {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  overflow: hidden;
}

.analytics-category-header {
  display: flex;
  background: #f4f4f4;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  text-align: left;
}

.header-item {
  display: flex;
  align-items: center;
  text-align: left;
}

.analytics-list-container {
  padding: 8px 0;
  max-height: none; /* Remove height limit to show all categories */
  overflow-y: visible; /* Change from auto to visible */
}

.analytics-list {
  display: flex;
  flex-direction: column;
}

.category-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.2s;
  
  &:hover {
    background: #f9f5ff;
  }
  
  &:last-child {
    border-bottom: none;
  }
}

.category-info {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 320px;
  text-align: left;
}

.category-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.category-name-modal {
  font-weight: 600;
  font-size: 14px;
  color: #333;
  white-space: normal;
  overflow: hidden;
  text-align: left;
}

.category-progress-container-modal {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-grow: 1;
  padding: 0 8px;
}

.category-progress-bar-modal {
  height: 8px;
  background-color: #f0f0f0;
  border-radius: 4px;
  flex-grow: 1;
  overflow: hidden;
  max-width: 180px;
}

.category-progress-fill-modal {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.category-progress-label-modal {
  font-size: 13px;
  font-weight: 600;
  color: #666;
  width: 40px;
  text-align: right;
}

.category-active-count,
.category-completed-count,
.category-total-count {
  width: 70px;
  text-align: center;
  font-size: 13px;
  color: #333;
  font-weight: 500;
}

.category-active-count {
  color: #FFC107;
}

.category-completed-count {
  color: #4CAF50;
}

.category-total-count {
  font-weight: 600;
}

.modal-footer {
  display: flex;
  justify-content: flex-start; /* Left-align the content */
  align-items: center;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #eee;
  text-align: left;
}

.total-count {
  font-size: 13px;
  color: #666;
  text-align: left;
}

.no-results {
  text-align: center;
  padding: 32px;
  color: #666;
  font-size: 14px;
}

/* Update Element UI Modal style */
:deep(.el-dialog__header) {
  padding: 20px 24px 0 !important;
  text-align: left !important;
}

:deep(.el-dialog__title) {
  text-align: left !important;
  font-weight: 700;
}

:deep(.el-dialog__body) {
  padding: 20px 0 !important;
}

:deep(.el-dialog) {
  border-radius: 24px !important;
  overflow: hidden;
}

:deep(.el-dialog__headerbtn) {
  top: 16px;
  right: 16px;
}
</style>

<style lang="scss" scoped>
/* Category Analytics Styles */
.category-analytics-dialog {
  border-radius: 24px !important;
  overflow: hidden;
}

.modal-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
  padding-left: 0;
  align-items: left;
}

.modal-title-text {
  display: flex;
  align-items: left;
  font-size: 22px;
  font-weight: 700;
  color: #333;
  text-align: left;
}

.modal-subtitle {
  font-size: 14px;
  color: #666;
  margin-top: 4px;
  text-align: left;
}

.category-analytics-modal-content {
  padding: 0 24px 24px;
  text-align: left;
}

.analytics-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 16px 0;
  border-bottom: 1px solid #eee;
  margin-bottom: 16px;
}

.analytics-filter {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-label {
  font-size: 14px;
  color: #666;
}

.time-period-select {
  width: 150px;
}

.analytics-search {
  width: 240px;
}

.analytics-summary {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.summary-card {
  background: #f8f8f8;
  border-radius: 16px;
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.summary-value {
  font-size: 24px;
  font-weight: 700;
  color: #6C30CC;
}

.summary-label {
  font-size: 14px;
  color: #666;
  margin-top: 4px;
}

.analytics-main {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  overflow: hidden;
}

.analytics-category-header {
  display: flex;
  background: #f4f4f4;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  text-align: left;
}

.header-item {
  display: flex;
  align-items: center;
  text-align: left;
}

.analytics-list-container {
  padding: 8px 0;
  max-height: none; /* Remove height limit to show all categories */
  overflow-y: visible; /* Change from auto to visible */
}

.analytics-list {
  display: flex;
  flex-direction: column;
}

.category-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.2s;
  
  &:hover {
    background: #f9f5ff;
  }
  
  &:last-child {
    border-bottom: none;
  }
}

.category-info {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 320px;
  text-align: left;
}

.category-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.category-name-modal {
  font-weight: 600;
  font-size: 14px;
  color: #333;
  white-space: normal;
  overflow: hidden;
  text-align: left;
}

.category-progress-container-modal {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-grow: 1;
  padding: 0 8px;
}

.category-progress-bar-modal {
  height: 8px;
  background-color: #f0f0f0;
  border-radius: 4px;
  flex-grow: 1;
  overflow: hidden;
  max-width: 180px;
}

.category-progress-fill-modal {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.category-progress-label-modal {
  font-size: 13px;
  font-weight: 600;
  color: #666;
  width: 40px;
  text-align: right;
}

.category-active-count,
.category-completed-count,
.category-total-count {
  width: 70px;
  text-align: center;
  font-size: 13px;
  color: #333;
  font-weight: 500;
}

.category-active-count {
  color: #FFC107;
}

.category-completed-count {
  color: #4CAF50;
}

.category-total-count {
  font-weight: 600;
}

.modal-footer {
  display: flex;
  justify-content: flex-start; /* Left-align the content */
  align-items: center;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #eee;
  text-align: left;
}

.total-count {
  font-size: 14px;
  color: #666;
  text-align: left;
}

.no-results {
  text-align: center;
  padding: 32px;
  color: #666;
  font-size: 14px;
}

/* Update Element UI Modal style */
:deep(.el-dialog__header) {
  padding: 20px 24px 0 !important;
  text-align: left !important;
}

:deep(.el-dialog__title) {
  text-align: left !important;
  font-weight: 700;
}

:deep(.el-dialog__body) {
  padding: 20px 0 !important;
}

:deep(.el-dialog) {
  border-radius: 24px !important;
  overflow: hidden;
}

:deep(.el-dialog__headerbtn) {
  top: 16px;
  right: 16px;
}

/* Analytics icon button */
.analytics-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.2s;
  padding: 6px;
  background: #f3eaff;
  
  &:hover {
    background: #e6d4ff;
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
}
</style>